// AI app builders export "standalone" bundles whose outer HTML is a loader
// shell with the real page JSON-encoded in a template script tag (assets live
// in a sibling base64 manifest that can push the template hundreds of KB into
// the file). Unwrap it here — before any upload truncation — so the pipeline
// imports the real page instead of the loading placeholder. Mirrors the
// server-side Remix::HtmlInlineSourceParser#unwrap_bundler_export.
const BUNDLER_TEMPLATE_SELECTOR = 'script[type="__bundler/template"]';
const BUNDLER_CHROME_SELECTOR =
  '[id^="__bundler"], [class^="__bundler"], .tweaks-panel';

const unwrapBundlerHtml = (raw) => {
  const text = String(raw || "");
  if (!text.includes("__bundler/template")) return text;

  try {
    const doc = new DOMParser().parseFromString(text, "text/html");
    const template = doc.querySelector(BUNDLER_TEMPLATE_SELECTOR);
    if (!template) return text;

    const unwrapped = JSON.parse(template.textContent);
    if (
      typeof unwrapped !== "string" ||
      !/<(html|body|section|main|header)\b/i.test(unwrapped)
    ) {
      return text;
    }

    const inner = new DOMParser().parseFromString(unwrapped, "text/html");
    inner
      .querySelectorAll(BUNDLER_CHROME_SELECTOR)
      .forEach((node) => node.remove());

    return `<!DOCTYPE html>\n${inner.documentElement.outerHTML}`;
  } catch (error) {
    console.warn("CF: bundler unwrap failed", error);
    return text;
  }
};

export default unwrapBundlerHtml;
